// flow
// todo(Oded): flow disabled because SVGGraphicsElement is not recognized
import axios from "axios";

import SVG from 'svg.js';

const parser = new DOMParser();
export const createSVGObjectFromString = (svgString: string) => {
    return parser.parseFromString(svgString, "image/svg+xml").documentElement;
};

export const getSVGObject = async (path: string): SVGGraphicsElement => {
    const response = await axios.get(path);
    return createSVGObjectFromString(response.data);
};

const serializer = new XMLSerializer();
const svgElementPrefix = "data:image/svg+xml;charset=UTF-8;base64,";
export const SVGToBase64Url = (svgElement: SVGGraphicsElement) => {
    return svgElementPrefix + btoa(serializer.serializeToString(svgElement));
};

const getHeightAndWidthOfSVG = (svgElement: SVGGraphicsElement): {height: number, width: number} => {
    if (!svgElement) {
        return {height: 0, width: 0};
    }
    const boundingBox = SVG(svgElement).bbox();
    if (boundingBox.x === 0) {
        return {height: svgElement.height.baseVal.value, width: svgElement.width.baseVal.value};
    } else {
        return {height: boundingBox.height, width: boundingBox.width};
    }
};

export const getBottomCenterAnchorFromSVG = (svgElement: SVGGraphicsElement): window.google.maps.Point => {
    const {height, width} = getHeightAndWidthOfSVG(svgElement);
    return new window.google.maps.Point(width / 2, height);
};

export const getCenterAnchorFromSVG = (svgElement: SVGGraphicsElement): window.google.maps.Point => {
    const {height, width} = getHeightAndWidthOfSVG(svgElement);
    return new window.google.maps.Point(width / 2, height / 2);
};

export const rotateSVGArray = (svgArray: Array<SVGGraphicsElement> | HTMLCollection<SVGGraphicsElement>,
                               heading?: number,
                               rotateAnchorX: number,
                               rotateAnchorY: number): void => {
    heading = heading || 0;
    for (let i = 0; i < svgArray.length; i = i + 1) {
        svgArray[i].setAttribute("transform", "rotate(" + heading + "," + rotateAnchorX + "," + rotateAnchorY + ")");
    }
};

export const getChildrenOfChildren = (svg: SVGGraphicsElement): Array<SVGGraphicsElement> => {
    const firstGeneration = svg.children;
    let secondGeneration = [];
    for (let i = 0; i < firstGeneration.length; i = i + 1) {
        secondGeneration.concat(firstGeneration[i].children);
    }
    return secondGeneration;
};



// WEBPACK FOOTER //
// ./src/Utils/SVGUtils.js